import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { IMPRESSUM } from "@/constants/testIds/landing";
import { useSiteContent } from "@/lib/siteContent";

const isEmpty = (v) => !v || !String(v).trim();

export default function Impressum() {
  const { content } = useSiteContent();
  const imp = content.impressum || {};
  const contactEmail = imp.email || content.contact_email;

  // If the user hasn't filled the responsible block, reuse the main address.
  const respName = imp.responsible_name || imp.name;
  const respStreet = imp.responsible_street || imp.street;
  const respCity = imp.responsible_postal_city || imp.postal_city;

  const noDataYet = isEmpty(imp.name) && isEmpty(imp.street) && isEmpty(imp.postal_city);

  return (
    <div
      data-testid={IMPRESSUM.page}
      className="min-h-screen bg-[#FAFAFA] text-[#1A1A1A]"
    >
      <Header onCtaClick={() => {}} />

      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            data-testid={IMPRESSUM.backToHome}
            className="inline-flex items-center gap-2 text-sm text-[#666] hover:text-[#6B8E23] transition-colors mb-8"
          >
            <ArrowLeft size={16} /> Zurück zur Startseite
          </Link>

          <h1 className="font-[Outfit] text-4xl sm:text-5xl font-bold tracking-tight mb-10">
            Impressum
          </h1>

          <article className="prose-meiei">
            {noDataYet && (
              <p className="text-sm text-[#B42318] bg-[#FEF3F2] border border-[#FECDCA] rounded-2xl px-4 py-3 mb-8">
                <strong>Hinweis:</strong> Die Impressum-Daten sind noch nicht
                ausgefüllt. Trag sie unter <code>/admin &rarr; Tab &bdquo;Inhalte&ldquo; &rarr; Impressum</code>
                {" "}ein.
              </p>
            )}

            <h2>Angaben gemäß § 5 DDG</h2>
            <p>
              {imp.name || "[Dein Name / Firmenname]"}
              <br />
              {imp.street || "[Straße und Hausnummer]"}
              <br />
              {imp.postal_city || "[PLZ und Ort]"}
              <br />
              {imp.country || "Deutschland"}
            </p>

            <h2>Kontakt</h2>
            <p>
              {!isEmpty(imp.phone) && (
                <>
                  Telefon: {imp.phone}
                  <br />
                </>
              )}
              E-Mail: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
            </p>

            {!isEmpty(imp.ust_id) && (
              <>
                <h2>Umsatzsteuer-ID</h2>
                <p>
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                  Umsatzsteuergesetz:
                  <br />
                  {imp.ust_id}
                </p>
              </>
            )}

            <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
              {respName || "[Dein Name]"}
              <br />
              {respStreet || "[Straße und Hausnummer]"}
              <br />
              {respCity || "[PLZ und Ort]"}
            </p>

            <h2>Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              .
              <br />
              Unsere E-Mail-Adresse findest du oben im Impressum.
            </p>
            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <h2>Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
              Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
              gespeicherte fremde Informationen zu überwachen oder nach
              Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
              hinweisen.
            </p>

            <h2>Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich.
            </p>

            <h2>Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht.
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}
